// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductFeed_wrapper__F9ls9","view_all":"ProductFeed_view_all__t_cWf"};